// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"9b1ee35e","453":"c0c3ab09","934":"5bb32e78"}[chunkId] + ".chunk.js";
};